module.exports = __webpack_public_path__ + "static/media/hamburger-oxford.733e8c88.svg";